.header {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
